import api from "services/api";

export const fetchClients = async () => {
  try {
    const response = await api.get("/Client", {
      params: { pageSize: 1000, pageNumber: 1 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching clients:", error);
    throw error;
  }
};

export const fetchContractors = async () => {
  try {
    const response = await api.get("/Contractor", {
      params: { pageSize: 1000, pageNumber: 1 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching contractors:", error);
    throw error;
  }
};

export const getDocumentTypes = async ({
  documentCategory,
  pageSize = 1000,
  pageNumber = 1,
  searchTerm,
  sortColumn,
  sortDirection = "ASC",
} = {}) => {
  const params = {
    pageSize,
    pageNumber,
    sortDirection,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (sortColumn) params.sortColumn = sortColumn;

  const endpoint = documentCategory ? "/DocumentType/category" : "/DocumentType";
  if (documentCategory) params.documentCategory = documentCategory;

  const res = await api.get(endpoint, { params });
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const createContract = async (contractData) => {
  try {
    const response = await api.post("/Contract", contractData);
    return response.data;
  } catch (error) {
    console.error("Error creating contract:", error);
    throw error;
  }
};

export const uploadContractDocument = async (formData) => {
  try {
    // Kiểm tra dữ liệu đầu vào
    if (!(formData instanceof FormData)) {
      throw new Error("Dữ liệu tải lên không đúng định dạng");
    }

    // Log chi tiết cho việc debug


    const fileObj = formData.get("File");
    if (fileObj) {

    } else {
      console.error("DEBUG SERVICE: No file found in FormData!");
      throw new Error("Không tìm thấy file trong FormData");
    }

    // Check if contractId is valid
    const contractId = formData.get("ContractId");
    if (!contractId) {
      console.error(
        "DEBUG SERVICE: ContractId is missing or invalid",
        contractId
      );
      throw new Error("Thiếu thông tin ID hợp đồng");
    }

    let response;

    // Try new endpoint first, then fall back to original if needed
    try {

      response = await api.post("/contract-documents/upload", formData);

    } catch (newEndpointError) {
      // Retry a write only when the route does not exist, never after an uncertain write.
      if (![404, 405].includes(newEndpointError.response?.status)) throw newEndpointError;
      console.error(
        "DEBUG SERVICE: Error with new endpoint:",
        newEndpointError
      );

      // Fallback to original endpoint
      try {

        response = await api.post("/contracts/documents/upload", formData);

      } catch (originalEndpointError) {
        console.error(
          "DEBUG SERVICE: Error with original endpoint:",
          originalEndpointError
        );
        throw originalEndpointError;
      }
    }

    return response.data;
  } catch (error) {
    console.error("DEBUG SERVICE: Error uploading contract document:", error);
    if (error.response) {
      console.error("DEBUG SERVICE: Error status:", error.response.status);
      console.error("DEBUG SERVICE: Error data:", error.response.data);
    } else {
      console.error("DEBUG SERVICE: Network or other error:", error.message);
    }
    throw error;
  }
};

export const getContractDocumentForPreview = async (documentId) => {
  try {
    const response = await api.get(
      `/contract-documents/download/${documentId}`,
      {
        responseType: "blob",
      }
    );
    return response;  // Return full response (có data, headers)
  } catch (error) {
    console.error(`Error getting document ${documentId}:`, error);
    throw error;
  }
};

export const addContractTeamMember = async (data) => {
  try {
    const requestData = {
      ...data,
      personnelId: data.personnelId,
      // Ensure displayOrder is included
      displayOrder: data.displayOrder || 0,
    };

    const response = await api.post("/ContractTeam", requestData);
    return response.data;
  } catch (error) {
    console.error("Error adding contract team member:", error);
    throw error;
  }
};

export const getContract = async (id) => {
  try {
    const response = await api.get(`/Contract/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching contract ${id}:`, error);
    throw error;
  }
};

export const updateContract = async (id, contractData) => {
  try {
    const response = await api.put(`/Contract/${id}`, contractData);
    return response.data;
  } catch (error) {
    console.error(`Error updating contract ${id}:`, error);
    error.message = error.response?.data?.message || error.message;
    throw error;
  }
};

export const getContractTeamMembers = async (contractId) => {
  try {
    const response = await api.get(`/ContractTeam/contract/${contractId}`);

    // Make sure we have the correct data structure
    if (response.data && response.data.data) {
      // Map backend fields to what we expect in frontend
      const members = response.data.data.map((member) => ({
        ...member,
        personnelId: member.personnelId,
        teamMemberId: member.contractTeamId,
      }));


      return members;
    }

    return [];
  } catch (error) {
    console.error(
      `Error fetching contract team members for contract ${contractId}:`,
      error
    );
    throw error;
  }
};

export const getContractDocuments = async (
  contractId,
  pageSize = 1000,
  pageNumber = 1
) => {
  try {
    if (!contractId) {
      console.error("Contract ID is undefined or null");
      return [];
    }

    // Try the new endpoint first with large pageSize to get all documents
    const newUrl = `/contract-documents/by-contract/${contractId}?pageSize=${pageSize}&pageNumber=${pageNumber}`;


    try {
      const response = await api.get(newUrl);

      if (response.data && Array.isArray(response.data.data)) {

        return response.data.data;
      } else if (response.data && Array.isArray(response.data)) {

        return response.data;
      } else {
        console.warn(
          "Unexpected document data format from new endpoint:",
          response.data
        );

        // Fall back to the old endpoint
        const fallbackResponse = await api.get(
          `/contracts/documents/by-contract/${contractId}?pageSize=${pageSize}&pageNumber=${pageNumber}`
        );

        if (
          fallbackResponse.data &&
          Array.isArray(fallbackResponse.data.data)
        ) {

          return fallbackResponse.data.data;
        } else if (
          fallbackResponse.data &&
          Array.isArray(fallbackResponse.data)
        ) {

          return fallbackResponse.data;
        } else {
          console.warn("No documents found in either endpoint");
          return [];
        }
      }
    } catch (fetchError) {
      console.error("Error fetching from new endpoint:", fetchError);

      // Fall back to the old endpoint
      try {

        const fallbackResponse = await api.get(
          `/contracts/documents/by-contract/${contractId}?pageSize=${pageSize}&pageNumber=${pageNumber}`
        );

        if (
          fallbackResponse.data &&
          Array.isArray(fallbackResponse.data.data)
        ) {
          return fallbackResponse.data.data;
        } else if (
          fallbackResponse.data &&
          Array.isArray(fallbackResponse.data)
        ) {
          return fallbackResponse.data;
        }
      } catch (fallbackError) {
        throw fallbackError;
      }

      throw new Error("Dữ liệu tài liệu hợp đồng trả về không hợp lệ.");
    }
  } catch (error) {
    console.error(
      `Error fetching contract documents for contract ${contractId}:`,
      error
    );
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
    }
    throw error;
  }
};

export const removeContractTeamMember = async (memberId) => {
  try {
    const response = await api.delete(`/ContractTeam/${memberId}`);
    return response.data;
  } catch (error) {
    console.error(`Error removing contract team member ${memberId}:`, error);
    throw error;
  }
};

export const updateContractTeamMember = async (memberId, data) => {
  try {
    // Ensure displayOrder is included in update data
    const requestData = {
      ...data,
      displayOrder: data.displayOrder !== undefined ? data.displayOrder : 0,
    };

    const response = await api.put(`/ContractTeam/${memberId}`, requestData);
    return response.data;
  } catch (error) {
    console.error(`Error updating contract team member ${memberId}:`, error);
    throw error;
  }
};

export const deleteContractDocument = async (documentId) => {
  try {
    const response = await api.delete(`/contract-documents/${documentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting contract document ${documentId}:`, error);
    throw error;
  }
};

export const downloadContractDocument = async (documentId, documentName) => {
  try {
    const response = await api.get(
      `/contract-documents/download/${documentId}`,
      {
        responseType: "blob",
      }
    );

    // Create a blob URL and trigger download
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Try to get filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let filename = documentName;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error(`Error downloading document ${documentId}:`, error);
    throw error;
  }
};

export const updateContractStatus = async (id, statusData) => {
  try {
    const response = await api.patch(`/Contract/${id}/status`, statusData);
    return response.data;
  } catch (error) {
    console.error(`Error updating contract status for ${id}:`, error);
    throw error;
  }
};

export const getContractStatusHistory = async (contractId) => {
  try {
    const response = await api.get(`/Contract/${contractId}/status-history`);
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching contract status history for ${contractId}:`,
      error
    );
    throw error;
  }
};

// Contract History APIs (tất cả loại thay đổi)
export const getContractHistory = async (
  contractId,
  entityType = null,
  pageNumber = 1,
  pageSize = 50
) => {
  try {
    const params = new URLSearchParams({
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    if (entityType) {
      params.append("entityType", entityType);
    }

    const response = await api.get(
      `/ContractHistory/contract/${contractId}?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching contract history for ${contractId}:`, error);
    throw error;
  }
};

export const getContractHistorySummary = async (contractId) => {
  try {
    const response = await api.get(
      `/ContractHistory/contract/${contractId}/summary`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching contract history summary for ${contractId}:`,
      error
    );
    throw error;
  }
};

export const getHistoryById = async (historyId) => {
  try {
    const response = await api.get(`/ContractHistory/${historyId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching history detail for ${historyId}:`, error);
    throw error;
  }
};

export const addContractHistory = async (historyData) => {
  try {
    const response = await api.post("/ContractHistory", historyData);
    return response.data;
  } catch (error) {
    console.error("Error adding contract history:", error);
    throw error;
  }
};

// Helper functions để track các loại thay đổi
export const trackContractCreate = async (contractId) => {
  try {
    const response = await api.post("/ContractHistory/track/contract-create", {
      contractId,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking contract creation:", error);
    throw error;
  }
};

export const trackContractUpdate = async (
  contractId,
  fieldName,
  fieldDisplayName,
  oldValue,
  newValue,
  changeReason = null
) => {
  try {
    const response = await api.post("/ContractHistory/track/contract-update", {
      contractId,
      fieldName,
      fieldDisplayName,
      oldValue,
      newValue,
      changeReason,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking contract update:", error);
    throw error;
  }
};

export const trackDocumentUpload = async (
  contractId,
  documentId,
  documentName,
  additionalInfo = null
) => {
  try {
    const response = await api.post("/ContractHistory/track/document-upload", {
      contractId,
      documentId,
      documentName,
      additionalInfo,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking document upload:", error);
    throw error;
  }
};

export const trackDocumentDelete = async (
  contractId,
  documentId,
  documentName,
  additionalInfo = null
) => {
  try {
    const response = await api.post("/ContractHistory/track/document-delete", {
      contractId,
      documentId,
      documentName,
      additionalInfo,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking document delete:", error);
    throw error;
  }
};

export const trackPersonnelAdd = async (
  contractId,
  personnelId,
  personnelName,
  additionalInfo = null
) => {
  try {
    const response = await api.post("/ContractHistory/track/personnel-add", {
      contractId,
      personnelId,
      personnelName,
      additionalInfo,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking personnel add:", error);
    throw error;
  }
};

export const trackPersonnelRemove = async (
  contractId,
  personnelId,
  personnelName,
  additionalInfo = null
) => {
  try {
    const response = await api.post("/ContractHistory/track/personnel-remove", {
      contractId,
      personnelId,
      personnelName,
      additionalInfo,
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking personnel remove:", error);
    throw error;
  }
};
